<template>
  <div class="tree-view-wrapper">
    <tree-view-item
      :data="parsedData"
      @change-data="onChangeData"
      class="tree-view-item-root"
      :max-depth="allOptions.maxDepth"
      :modifiable="allOptions.modifiable"
      :current-depth="allOptions.maxDepth"
    />
  </div>
</template>

<script>
import TreeViewItem from "./TreeViewItem.vue";
import {
  map,
  isArray,
  isPlainObject,
  last,
  drop,
  dropRight,
  cloneDeep,
  forEach,
  extend
} from "lodash";

export default {
  components: {
    TreeViewItem
  },
  name: "tree-view",
  props: ["data", "options"],
  methods: {
    // Transformer for the non-Collection types,
    // like String, Integer of Float
    transformValue: function(valueToTransform, keyForValue) {
      return {
        type: "value",
        key: keyForValue,
        value: valueToTransform
      };
    },

    // Since we use lodash, the loadsh map method will work on
    // both Objects and Arrays, returning either the Key as
    // a string or the Index as an integer
    generateChildrenFromCollection: function(collection) {
      return map(collection, (value, keyOrIndex) => {
        if (isPlainObject(value)) {
          return this.transformObject(value, keyOrIndex);
        }
        if (isArray(value)) {
          return this.transformArray(value, keyOrIndex);
        }
        if (this.isValue(value)) {
          return this.transformValue(value, keyOrIndex);
        }
      });
    },

    // Transformer for the Array type
    transformArray: function(arrayToTransform, keyForArray) {
      return {
        type: "array",
        key: keyForArray,
        children: this.generateChildrenFromCollection(arrayToTransform)
      };
    },

    // Transformer for the Object type
    transformObject: function(
      objectToTransform,
      keyForObject,
      isRootObject = false
    ) {
      return {
        type: "object",
        key: keyForObject,
        isRoot: isRootObject,
        children: this.generateChildrenFromCollection(objectToTransform)
      };
    },

    isValue: function(value) {
      return !isPlainObject(value) && !isArray(value);
    },

    onChangeData: function(path, value) {
      let lastKey = last(path);
      path = dropRight(drop(path));

      let data = cloneDeep(this.data);
      let targetObject = data;
      forEach(path, key => {
        targetObject = targetObject[key];
      });

      if (targetObject[lastKey] != value) {
        targetObject[lastKey] = value;
        this.$emit("change-data", data);
      }
    }
  },
  computed: {
    allOptions: function() {
      return extend(
        {},
        {
          rootObjectKey: "تغییرات",
          maxDepth: 4,
          modifiable: false
        },
        this.options || {}
      );
    },
    parsedData: function() {
      // Take the JSON data and transform
      // it into the Tree View DSL

      // Strings or Integers should not be attempted to be split, so we generate
      // a new object with the string/number as the value
      if (this.isValue(this.data)) {
        return this.transformValue(this.data, this.allOptions.rootObjectKey);
      }

      // If it's an object or an array, transform as an object
      return this.transformObject(
        this.data,
        this.allOptions.rootObjectKey,
        true
      );
    }
  }
};
</script>

<style scoped>
/* Find the first nested node and override the indentation */
.tree-view-item-root > .tree-view-item-leaf > .tree-view-item {
  margin-right: 0 !important;
}

/* Root node should not be indented */
.tree-view-item-root {
  margin-right: 0 !important;
}
</style>
